import { createContext, useContext } from 'react';

// 10 ago 2026 (Augusto: "no aparece un indicador si va a ingresar más
// cuentas o deudas o no"): investigando, el checklist de la barra
// lateral (OnboardingSidebar.js, vía NotionLayout.js) solo vuelve a
// pedir /onboarding/data cuando cambia location.pathname -- si el
// cliente agrega una cuenta o deuda SIN cambiar de ruta (el caso normal:
// se queda en /accounts o /debts agregando varias seguidas), el check
// de esa barra se queda sin marcar aunque el backend ya lo tenga como
// completado. Eso es lo que reportó Augusto como "no aparece un
// indicador" -- el cliente agrega una deuda real y no ve ninguna
// confirmación de que ese paso quedó listo.
//
// Este contexto expone una función `triggerOnboardingRefresh` que
// NotionLayout.js provee (envolviendo su propio contenido) y que
// cualquier página hija (CuentasPage.js, DebtsPage.js) puede llamar
// después de crear un registro con éxito, para forzar un nuevo pedido a
// /onboarding/data sin necesidad de navegar a otra ruta.
export const OnboardingRefreshContext = createContext(() => {});

export const useOnboardingRefresh = () => useContext(OnboardingRefreshContext);

export default OnboardingRefreshContext;
